<template>
  <div class="home_container">
    <div :class="screenWidth > 1800 ? '' : 'normal'">
      <el-carousel
        :interval="3000"
        trigger="click"
        :height="bannerHeight + 'px'"
      >
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div v-lazy:background-image="item.img" class="content">
            <div :class="'label_box '">
              <div class="label_title">{{ item.title }}</div>
              <div class="sonTitle">{{ item.sonTitle }}</div>
              <div class="word_content">{{ item.content }}</div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="qrcode_box">
        <div class="title">尊敬的用户</div>
        <div class="tips1">
          您是不是被以下问题困扰<br />什么生意适合引进智能柜/售货机赋能
        </div>
        <div class="tips2">
          您处的行业应该如何选型智能柜/售货机<br />
          网上这么多的智能柜/售货机厂家，应该怎么选择？<br />
          智能柜/售货机怎么使用？价格怎样？<br />
          智能柜/售货机项目应如何运营？<br />
          什么场景需要智能柜/售货机？<br />
          智能柜/售货机如何赚钱？
        </div>
        <div style="color:#FC9900" class="tips2">
          这一切问题<br />
          都可以交给我们来帮您解答！<br />
          解惑扫码
        </div>
        <img
          class="qrcode_img"
          v-lazy="require('../images/homePage/qrcode.png')"
          alt=""
        />
        <div class="tips3">企业微信客户二维码</div>
      </div>
      <div class="introduce_box">
        <div class="i_title">奕优微仓是国内智能柜/售货机行业的领跑者</div>
        <div class="i_sonTitle">
          我们的客户均来自军工，航天工业，重工业及行业巨头企业
        </div>
      </div>
      <div
        :style="
          'background-image:url(' +
            require('../images/introduce/i_bg.png') +
            ')'
        "
        class="introduce"
      >
        <div class="son_box">
          <div class="title">公司荣誉</div>
          <div class="en_title">Company honor</div>
          <div class="tips">版式有限 部分展示</div>
        </div>
        <div class="zhuanli_area">
          <el-row>
            <el-col :span="13">
              <div class="title">专利证书</div>
              <div class="en_title">Qualification certificate</div>
              <div class="list">
                <div v-for="item in 8" :key="item" class="item">
                  <img
                    class="img"
                    v-lazy="require(`../images/introduce/zhuanl${item}.png`)"
                    alt=""
                  />
                </div>
              </div>
            </el-col>
            <el-col :span="11">
              <div class="title">专利证书</div>
              <div class="en_title">Qualification certificate</div>
              <div class="list">
                <div v-for="item in 3" :key="item" class="item1">
                  <img
                    class="img"
                    v-lazy="
                      require(`../images/introduce/zhuanl${item + 8}.png`)
                    "
                    alt=""
                  />
                </div>
              </div>

              <div style="margin-left: 2%;" class="title">荣誉客户</div>
              <div style="margin-left: 2%;" class="en_title">
                Honorable customers
              </div>
              <img
                class="customer_img"
                v-lazy="require('../images/introduce/customer.png')"
                alt=""
              />
            </el-col>
          </el-row>
        </div>
        <div class="bottom_box">
          <div class="b_tips1">
            奕优微仓是国家高新技术企业，产品都是自主研发生产<br />
            拥有4项发明专利、50多项实用新型专利和软件著作权，同行一般只有几项外观专利
          </div>
          <div class="b_tips2">
            是中国少有的一家从内到外、从硬件到软件，全部独家专利的公司
          </div>
        </div>
      </div>
      <div class="problem_box">
        <img v-lazy="require('../images/homePage/problem.png')" alt="" />
        <div class="right_box">
          <div class="title">智能柜/售货机存在的四大问题</div>
          <div class="item">· 货损</div>
          <div class="item">· 更换商品麻烦</div>
          <div class="item">· 隐形成本高</div>
          <div class="item">· 售后得不到保障</div>
          <div class="item">
            用户往往在购买使用后才发现有很多的问题，最后导致意想不到的损失。
            奕优微仓团队拥有19年设备制造管理、软件定制、电子集成的经验；在产
            品的功能、质量、用户体验上有着深厚的研究。
          </div>
          <div class="tips">绝不把客户当小白鼠</div>
        </div>
      </div>
      <div class="box1">
        <div class="left_box">
          <div class="title">
            我们的产品一直被模仿，但从未被超越<br />
            产品功能即使原地踏步，也许同行3年也赶不上
          </div>
          <div class="tips">
            我们熟悉智能柜/售货机运营中的一切问题，<br />
            并一直倡导”不让您购买后再花冤枉钱”，<br />
            期待我们今次能合作成功，相信您不会有遗憾或被愚弄欺骗的感觉。<br />
            奕优微仓是您最值得信赖的合作伙伴！
          </div>
        </div>
        <div class="right_box">
          <img
            class="qrcode_img"
            v-lazy="require('../images/homePage/qrcode.png')"
            alt=""
          />
          <div class="tips">了解更多请扫码(企业微信客服二维码)</div>
        </div>
      </div>
      <div class="capsule_box">
        <div class="title">微仓X5</div>
        <div class="son_title">
          占地1.5平方，可放987不同SKU，无需专业知识和工具可任意更换商品
        </div>
        <el-row class="list" :gutter="120">
          <el-col
            class="item"
            v-for="item in capsuleList"
            :key="item.name"
            :span="6"
            ><img v-lazy="item.url" alt="" />
            <div class="label">{{ item.name }}</div>
          </el-col>
        </el-row>
      </div>
      <div class="service_box">
        <el-row :gutter="60">
          <el-col :span="8">
            <img v-lazy="require('../images/homePage/service1.png')" alt="" />
            <div class="title">一、售前服务承诺</div>
            <div class="tips">
              1、提供专业咨询。在2小时之内答复您提出的专业技术问题；<br />
              2、提供详细资料。在4小时之内将发您所需要的技术资料；<br />
              3、提供合理报价。在2小时之内为您提供合理报价；<br />
              4、提供考察接待。随时接待您的考察，并尽力为您的考察工作提供各种便利条件。
            </div>
          </el-col>
          <el-col :span="8">
            <img v-lazy="require('../images/homePage/service2.png')" alt="" />
            <div class="title">二、售中服务承诺</div>
            <div class="tips">
              1、采用全国统一的《工业品买卖合同》与您签订合同和技术协议；<br />
              2、自觉遵守合同发的规定，确保合同及技术协议顺利旅行；<br />
              3、竭力按时按量为您提供优质产品，并采用最优运输方式，确保您收到货物完好无缺；<br />
              4、积极与使用人员沟通，尊重用户安排，为用户提供周到的技术支持；<br />
              5、无论合同大小，所有客户在价格及服务方面都是公平的。
            </div>
          </el-col>
          <el-col :span="8">
            <img v-lazy="require('../images/homePage/service3.png')" alt="" />
            <div class="title">三、售后服务承诺</div>
            <div class="tips">
              1、建立客户档案，并将按照客户的要求提供相关的技术培训和技术资料；<br />
              2、产品有质量问题，三年免费保修，终生维修，有合同约定的按合同约定；<br />
              3、我们保证在15分钟内进行电话指导，由您自行排除设备的简单故障。
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="keng_box">
        <div class="center">
          <div class="title">行业里的“坑”</div>
          <div class="tips">
            坑一：大部分厂家的前身是五金加工厂，找了三两个程序员临时搭建起智能平台，系统运行不稳定，一旦大规模运营，系统就会经常崩溃，让用户的参与度降低，项目运营失败；<br />
            坑二：大部份的厂家只能提供智能柜/售货机，但完全不懂商业项目运营，制造的设备也不适合运营使用，更无法给客户提供运营服务帮助；<br />
            坑三：智能柜/售货机设备的研发和维护成本巨大，很多的设备厂家的抗风险能力差，一旦厂家倒闭，运营企业所采购的设备将会全部报废；<br />
            坑四：大部分厂商都是回答你什么样的智能柜/售货机都能做，其实在产品设计上完全没有考虑兼容性和标准化，产品故障率高，给运营企业带来大量的售后维护成本；<br />
            坑五：大部分的厂家无法提供本地化的售后服务，一旦设备出现硬件故障无法在短期内解决，让运营企业长时间停止服务，导致被客户罚款或问责；<br />
            坑六：大部分厂家的智能柜/售货机缺少安全设计，常常引发重摔货损，结构漏洞导致账务不符和取货口夹人的安全事故，给项目运营企业带来得重大损失；
          </div>
          <div style="color:#FC9900" class="tips">
            综上所述，纯粹从价格去比较各家的智能柜/售货机，基本上无法体现你我的价值，而微仓智能柜不愿意销售貌似很低廉价格，但不能给你项目带来价值的产品。
          </div>
        </div>
      </div>
      <div class="point_box">
        <div class="title">微仓(智能柜)具有80%的同行几乎做不到的12个特点</div>
        <el-row style="flex-wrap: wrap;" type="flex" :gutter="44">
          <el-col v-for="item in pointList" :key="item.title" :span="6">
            <img :src="item.url" alt="" />
            <div class="point_title">{{ item.title }}</div>
            <div class="point_content">{{ item.name }}</div>
          </el-col>
        </el-row>
      </div>
      <div class="bottomTips">
        <span
          @click="goOtherWeb(item)"
          v-for="item in bottomTips"
          :key="item.label"
          class="item"
          >{{ item.label }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";

export default {
  data() {
    return {
      bannerList: [
        {
          img: require("../images/banner/banner1.png"),
          title: "选择微仓产品的八大理由之一",
          sonTitle: "货容量高，低补货成本",
          content:
            "微仓X5是目前市场上其他设备货容量的3倍，一台顶其他设备三台（可以减少补货次数和最低场地成本，极大程度的降低运营成本）"
        },
        {
          img: require("../images/banner/banner2.png"),
          title: "选择微仓产品的八大理由之二",
          sonTitle: "随意更换商品，迎合需求变化，零成本变换货道",
          content:
            "经营是持续优化的过程，更换商品是常态，微仓的柔性杜绝隐形成本，更加不会产生二次包装成本"
        },
        {
          img: require("../images/banner/banner3.jpg"),
          title: "选择微仓产品的八大理由之三",
          sonTitle: "赋能多样价值，增加经济效益",
          content:
            "智能柜/售货机从设计之初，就考虑到多媒体载体的属性，让你的项目更加吸引眼球，增添附加经济效益"
        },
        {
          img: require("../images/banner/banner4.png"),
          title: "选择微仓产品的八大理由之四",
          sonTitle: "多种登录支付方式，灵活使用",
          content: "拥有五种身份识别+五种结账模式"
        },
        {
          img: require("../images/banner/banner5.png"),
          title: "选择微仓产品的八大理由之五",
          sonTitle: "兼容多行业，实现数字化升级",
          content:
            "中国少有的能兼容多行业系统软件，MRO物料智能管理系统，售卖系统，派样引流系统…\n可私有化部署及品牌订制，零成本变换赛道；让您3天实现数字化成为高科技企业"
        },
        {
          img: require("../images/banner/banner6.png"),
          title: "选择微仓产品的八大理由之六",
          sonTitle: "严格检验，品质保障",
          content:
            "产品生产共经过33道功能检测，并老化测试48小时后，才能出厂。产品质保3年，是市场同类产品质保期的3倍"
        },
        {
          img: require("../images/banner/banner7.png"),
          title: "选择微仓产品的八大理由之七",
          sonTitle: "高标准原材料，产品更耐用",
          content:
            "产品电器件80%采用军工级材料，所使用线材全部为铜线，市场同类产品大多数使用铝材。"
        },
        {
          img: require("../images/banner/banner8.png"),
          title: "选择微仓产品的八大理由之八",
          sonTitle: "高规格工艺，打造高规格产品",
          content: "柜体表面处理，使用格力空调主机同款素粉及相同的加工工艺"
        }
      ],
      capsuleList: [
        {
          name: "3C数码手机智能柜",
          url: require("../images/homePage/capsule1.png")
        },
        {
          name: "保密单位手机存储柜",
          url: require("../images/homePage/capsule2.png")
        },
        {
          name: "银行贵金属售卖柜",
          url: require("../images/homePage/capsule3.png")
        },
        {
          name: "智能刀具工具柜",
          url: require("../images/homePage/capsule4.png")
        },
        {
          name: "智能药品柜",
          url: require("../images/homePage/capsule5.png")
        },
        {
          name: "智能派样柜",
          url: require("../images/homePage/capsule6.png")
        },
        {
          name: "汽车厂钥匙管理柜",
          url: require("../images/homePage/capsule7.png")
        },
        {
          name: "银行印鉴卡管理柜",
          url: require("../images/homePage/capsule8.png")
        }
      ],
      pointList: [
        {
          title: "特点①",
          name:
            "1、微仓拥有近20年制造工厂管理经验，而且一直专注于单元化物料管理领域为近3000家工厂客户提供服务，我们设计的微仓（智能柜）被全国35%以上航空航天军工企业选用，同行无法模仿。",
          url: require("../images/homePage/point1.png")
        },
        {
          title: "特点②",
          name:
            "2、微仓（智能柜）已经有过6次升级，且每年都有新款推出，同行难以做到。",
          url: require("../images/homePage/point2.png")
        },
        {
          title: "特点③",
          name:
            "3、微仓智能柜均使用24V安全电压，确保项目运营的安全性，不会产生额外损失。",
          url: require("../images/homePage/point3.png")
        },
        {
          title: "特点④",
          name:
            "4、系统稳定，已连续运行1800多天，使用并发率高，满足10万个用户同时使用也不会丢失一个数据，秒杀同行。",
          url: require("../images/homePage/point4.png")
        },
        {
          title: "特点⑤",
          name:
            "5、微仓是中国少有的一家从机械制造、电子集成、软件研发一体的智能柜/售货机厂家，市场上大部分要么是信息化公司硬件外采装配，要么钣金厂外包软件。",
          url: require("../images/homePage/point5.png")
        },
        {
          title: "特点⑥",
          name:
            "6、所有智能产品均经过33道功能检测程序、48小时老化运行合格才可出厂，3年0投诉、0退货，同行做不到。",
          url: require("../images/homePage/point6.png")
        },
        {
          title: "特点⑦",
          name:
            "7、微仓智能柜的表面处理选择与格力空调同样的涂料和工艺，保证3年不褪色，10年不脱落。",
          url: require("../images/homePage/point7.png")
        },
        {
          title: "特点⑧",
          name:
            "8、微仓是最懂MRO物料管理项目运营方法的设备制造商，赋能各地多家MRO工业品贸易商成功转型。",
          url: require("../images/homePage/point8.png")
        },
        {
          title: "特点⑨",
          name:
            "9、微仓已经拥有100多项技术发明和外观专利，十余项软件著作权，远超国内同行，引领着行业的技术标准。",
          url: require("../images/homePage/point9.png")
        },
        {
          title: "特点⑩",
          name:
            "10、微仓赋能多行业，可提供自有知识产权行业Saas系统，可随时变更赛道，让你项目几乎零风险。",
          url: require("../images/homePage/point10.png")
        },
        {
          title: "特点⑪",
          name:
            "11、公司设有售前、售中和售后服务专员，多对一进行保姆式贵宾服务，解决不同阶段的问题和需求。",
          url: require("../images/homePage/point11.png")
        },
        {
          title: "特点⑫",
          name:
            "12、常规产品计划性备货100台以上，满足客户打款后三天内交货的需求，同行难以做到。",
          url: require("../images/homePage/point12.png")
        }
      ],
      bottomTips: [
        { label: "IEOU©2023", path: "" },
        {
          label: "沪ICP备19026522号-3",
          path: "https://beian.miit.gov.cn/#/Integrated/index"
        },
        { label: "隐私和法律", path: "" },
        { label: "联系我们", path: "" },
        { label: "最新消息", path: "" }
      ]
    };
  },

  computed: {
    bannerHeight() {
      let width = store.state.screenWidth;
      width = width > 1366 ? width : 1366;
      let height = width / 2.66;
      return height;
    },
    screenWidth() {
      return store.state.screenWidth;
    }
  },
  methods: {
    goOtherWeb(item) {
      if (item.path) {
        window.open(item.path);
      }
    }
  }
};
</script>

<style lang="less">
.home_container {
  padding-top: 53px;
  .bottomTips {
    height: 52px;
    text-align: center;
    background-color: #fff;
    line-height: 52px;
    .item {
      padding: 0 1.6%;
      color: #000000;
      cursor: pointer;
    }
  }
  .point_box {
    padding: 46px 10%;
    background-color: #f2f2f2;
    img {
      height: 80px;
      margin: 0 auto;
      width: auto;
    }
    .point_title {
      text-align: center;
      font-weight: bold;
      font-size: 16px;
      margin: 10px 0 6px 0;
    }
    .point_content {
      font-size: 14px;
      max-width: 300px;
      margin: 0 auto;
      line-height: 24px;
    }
    .title {
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 17px;
    }
  }
  .keng_box {
    padding: 46px 0 24px;
    position: relative;
    height: 340px;
    .center {
      white-space: nowrap;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      width: auto;
    }
    .title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 16px;
      text-align: center;
    }
    .tips {
      font-size: 14px;
      line-height: 28px;
    }
  }
  .service_box {
    padding: 46px 10%;

    background: #f2f2f2;
    img {
      width: 90px;
      margin: 0 auto;
    }
    .title {
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      margin: 14px 0;
    }
    .tips {
      font-size: 13px;
      line-height: 20px;
    }
  }
  .capsule_box {
    background-color: #fff;
    padding: 46px 9%;
    text-align: center;
    .list {
      .item {
        margin-top: 44px;
      }
      .label {
        text-align: center;
        padding-top: 16px;
        color: rgba(0, 0, 0, 0.75);
      }
      img {
        margin: 0 auto;
        height: 380px;
        width: auto;
      }
    }
    .title {
      font-weight: bold;
      font-size: 30px;
      margin-bottom: 14px;
    }
    .son_title {
      font-size: 24px;
    }
  }
  .box1 {
    background: #f2f2f2;
    padding: 46px 0;
    .left_box {
      display: inline-block;
      margin-right: 8%;
      margin-left: 16.5%;
      vertical-align: top;
      padding-top: 4%;
      .title {
        font-weight: bold;
        font-size: 26px;
        margin-bottom: 17px;
      }
      .tips {
        font-size: 14px;
      }
    }
    .right_box {
      display: inline-block;
      width: 28%;
      img {
        width: 380px;
        margin: 0 auto;
      }
      .tips {
        text-align: center;
        font-size: 12px;
        padding-top: 10px;
        color: rgba(0, 0, 0, 0.55);
      }
    }
  }
  .problem_box {
    padding: 64px 0;
    .right_box {
      display: inline-block;
      width: 30%;
      padding-top: 4%;
      .title {
        font-size: 26px;
        margin-bottom: 10px;
        font-weight: bold;
      }
      .item {
        font-size: 14px;
        line-height: 24px;
      }
      .tips {
        padding-top: 7px;
        font-size: 18px;
        color: #fc9900;
      }
    }
    img {
      width: 29%;
      vertical-align: top;
      display: inline-block;
      margin: 0 8% 0 16.5%;
    }
  }
  .bottom_box {
    margin: 0 4%;
    border-top: 1px solid #7d2b06;
    text-align: center;
    font-size: 30px;
    padding-top: 3%;
    .b_tips1 {
      margin-bottom: 1.5%;
    }
    .b_tips2 {
      color: #fc9900;
      padding-bottom: 3%;
    }
  }
  .introduce {
    position: relative;
    height: auto;
    background: 60% 25% no-repeat;
    background-size: cover;
    .customer_img {
      margin-left: 3%;
      margin-top: 1%;
      width: 90%;
    }
    .list {
      .item1 {
        width: 29.5%;
        display: inline-block;
        margin: 0 1.75%;
        margin-bottom: 4%;
      }
      .item {
        width: 25%;
        display: inline-block;
        margin-bottom: 4%;
      }
      .img {
        width: 80%;
        max-width: 190px;
        max-height: 249px;
        margin: 10% auto;
      }
    }
    .zhuanli_area {
      color: #7d2b06;
      margin: 4% 2% 0% 3%;
      .title {
        padding-left: 2%;
        font-size: 26px;
      }
      .en_title {
        padding-left: 2%;

        font-size: 20px;
      }
    }
    .son_box {
      text-align: center;
      color: #fff;
      .title {
        padding-top: 2%;
        font-size: 54px;
      }
      .en_title {
        font-size: 28px;
        margin-bottom: 0.8%;
      }
      .tips {
        font-size: 16px;
      }
    }
  }
  .introduce_box {
    padding: 64px;
    text-align: center;
    .i_title {
      font-weight: bold;
      font-size: 38px;
      margin-bottom: 24px;
    }
    .i_sonTitle {
      color: rgba(0, 0, 0, 0.75);
      font-size: 30px;
    }
  }
  .qrcode_box {
    background: #f2f2f2;
    text-align: center;
    padding: 64px;
    .qrcode_img {
      width: 310px;
      height: 310px;
      margin: 24px auto 10px auto;
    }
    .title {
      font-size: 38px;
      font-weight: bold;
      margin-bottom: 8px;
    }
    .tips1 {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.75);
      margin-bottom: 16px;
    }
    .tips2 {
      color: rgba(0, 0, 0, 0.55);
      font-size: 18px;
      margin-bottom: 16px;
    }
    .tips3 {
      color: rgba(0, 0, 0, 0.55);

      font-size: 16px;
    }
  }
  .label_box {
    width: 35%;
    padding-top: 12%;
    color: #fff;
    .word_content {
      font-size: 28px;
      white-space: pre-wrap;
    }
    .label_title {
      font-size: 46px;
      margin-bottom: 10px;
    }
    .sonTitle {
      font-size: 34px;
      margin-bottom: 40px;
    }
  }
  .normal {
    .capsule_box {
      .item {
        margin-top: 34px;
      }
      img {
        height: 280px;
      }
    }
    .zhuanli_area {
      margin: 2% 2% 0% 3%;
    }

    .label_box {
      .word_content {
        font-size: 18px;
      }
      .label_title {
        font-size: 28px;
      }
      .sonTitle {
        font-size: 24px;
      }
    }
    .son_box {
      .title {
        padding-top: 34px;
      }
    }
  }
  .content {
    position: relative;
    padding-left: 5%;
    height: 100%;
    background: 85% no-repeat;
    background-size: cover;
    // background-origin: content-box;
  }
}
</style>
